var t=()=>o;function o(...n){}export{t as a};
